<template>
  <v-app-bar
    id="core-app-bar"
    absolute
    app
    color="#fff"
    elevation="2"
    flat
    height="69"
  >
    <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
      <v-row align="center" justify="center">
        <v-col cols="auto">
          <v-btn v-if="responsive" class="mx-1" icon @click.stop="onClick">
            <v-icon>mdi-view-list</v-icon>
            <v-badge
              v-if="$store.state.notification.notif > 0"
              dot
              offset-y=".1"
              offset-x="9"
              class="mt-1"
              bottom
              right
              color="red darken-2"
              overlap
            />
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-icon
            class="pb-1"
            :size="$store.state.isMobile ? 24 : 25"
            color="#a9a7a7"
          >
            {{ $store.state.link.icon }}
          </v-icon>
        </v-col>
        <v-col class="pl-1" cols="auto" v-if="!$store.state.isMobile">
          <span class="title black--text">
            {{ this.$t(`drawer.${$store.state.link.text}`) }}
          </span>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-spacer />

    <!--template v-if="this.$store.state.ui.localhost">
      <v-toolbar-items>
        <v-row
          align="center"
          class="mx-0"
        >
          <v-text-field
            class="mr-4 purple-input"
            color="purple"
            label="Search..."
            hide-details
          />

          <v-btn
            icon
            to="/"
          >
            <v-icon color="tertiary">
              mdi-view-dashboard
            </v-icon>
          </v-btn>

          <v-menu
            bottom
            left
            offset-y
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                class="toolbar-items"
                icon
                to="/notifications"
                v-bind="attrs"
                v-on="on"
              >
                <v-badge
                  color="error"
                  overlap
                >
                  <template slot="badge">
                    {{ notifications.length }}
                  </template>
                  <v-icon color="tertiary">
                    mdi-bell
                  </v-icon>
                </v-badge>
              </v-btn>
            </template>

            <v-card>
              <v-list dense>
                <v-list-item
                  v-for="notification in notifications"
                  :key="notification"
                  @click="onClick"
                >
                  <v-list-item-title v-text="notification" />
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>

          <v-btn
            to="/user-profile"
            icon
          >
            <v-icon color="tertiary">
              mdi-account
            </v-icon>
          </v-btn>
        </v-row>
      </v-toolbar-items>
    </template-->

    <v-toolbar-items>
      <v-row no-gutters align="center" class="mx-0">
        <v-col>
          <v-select
            v-if="this.storeId == '0'"
            :items="storeIds"
            label="Store Ids"
            outlined
            @change="selectStoreId"
          />
        </v-col>
        <v-col v-show="!$store.state.isMobile">
          <v-list-item>
            <v-list-item-avatar class="mr-1">
              <v-icon size="27" color="grey darken-3"> mdi-store </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <h5 class="font-weight-reguler">
                  {{ $store.state.store.store.store_name }}
                </h5>
              </v-list-item-title>
              <v-list-item-subtitle>
                <h5 class="primary--text">
                  {{ $store.state.store.store.url }}
                </h5>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="auto">
          <v-menu offset-y color="primary">
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                elevation="0"
                color="transparent"
                class="pa-1"
                v-bind="attrs"
                v-on="{ ...menu }"
              >
                {{ $store.state.isMobile ? $t("lang_mobile") : $t("lang") }}
                <v-icon size="18" class="ma-1"> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list dense :subheader="true">
              <v-list-item-group
                v-model="$i18n.locale"
                active-class="border"
                color="#1141ce"
                value="true"
              >
                <v-list-item
                  v-for="(lang, i) in $i18n.availableLocales"
                  :key="`Lang${i}`"
                  :value="lang"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="lang" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-col>
        <v-col v-if="this.$store.state.admin.connected">
          <v-tooltip bottom color="black">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                color="black"
                @click="
                  () => {
                    $store.dispatch('setSysExport', { showing: true });
                  }
                "
              >
                <v-icon>mdi-database-export</v-icon>
              </v-btn>
            </template>
            <span>Export System</span>
          </v-tooltip>
        </v-col>
        <v-col>
          <v-btn
            v-if="this.$store.state.admin.connected"
            icon
            color="error"
            @click="
              () => {
                this.$store.dispatch('SIGN_OUT');
              }
            "
          >
            <v-icon>mdi-power</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
// Utilities
import { mapMutations } from "vuex";

export default {
  data: () => ({
    notifications: [
      "Mike, John responded to your email",
      "You have 5 new tasks",
      "You're now a friend with Andrew",
      "Another Notification",
      "Another One",
    ],
    title: null,
    responsive: false,
    storeIds: undefined,
  }),

  computed: {
    storeId() {
      return this.$store.state.admin.storeId;
    },
    store() {
      return this.$store.state.store.store;
    },
  },

  watch: {
    $route(val) {
      this.title = val.name;
    },
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClick() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onResponsiveInverted() {
      if (window.innerWidth <= 1260) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    selectStoreId(value) {
      window.localStorage.setItem("selected_storeId", value);
      this.$store.dispatch("FETCH_STORE");
      this.$store.dispatch("FETCH_PRODUCTS").then(() => {
        this.$store.dispatch("FETCH_LOOKS");
      });
      if (this.$route.query.redirect != undefined) {
        this.$router.push({ path: this.$route.query.redirect });
      }
    },
  },
};
</script>

<style scoped>
* {
  font-family: Futura, Trebuchet MS, Arial, sans-serif;
}
/* Fix coming in v2.0.8 */
#core-app-bar {
  width: auto;
}

#core-app-bar a {
  text-decoration: none;
}
</style>
